import { env } from '@/config/env'
import { browserRuntimeFreeze } from 'oidc-spa/browser-runtime-freeze'
import { oidcEarlyInit } from 'oidc-spa/entrypoint'

// Initialize OIDC early for enhanced security and performance
// This intercepts the authentication callback before any other code runs
const { shouldLoadApp } = oidcEarlyInit({
  // The path where your app is hosted (from type-safe env)
  BASE_URL: env.BASE_URL,

  // Security defenses for production-ready enterprise apps
  securityDefenses: {
    // Prevent monkey-patching of browser APIs for security
    ...browserRuntimeFreeze({
      // Optionally exclude certain APIs if needed for compatibility
      // excludes: ["fetch", "XMLHttpRequest"]
    }),

    // DPoP disabled: backend uses standard JWT Bearer auth and does not support DPoP.
    // Auto mode causes FormData uploads to fail because the retry after DPoP rejection
    // can't re-send consumed FormData body streams.
    // Re-enable with `...DPoP({ mode: "auto" })` when backend adds DPoP support.
  },
})

if (shouldLoadApp) {
  // Defer loading the main application
  // This adds a few milliseconds to cold start but dramatically speeds up auth
  import('./main.lazy')
}
